import { FC } from "react";
// styles
import "./index.css";
// Assets
import heroMobileImage from "../../assets/images/heroMainPic.svg";
import logo from "../../assets/images/desktopLogo.svg";
// Constants
import texts from "../../constants/texts.json";
import NavBar from "../../components/NavBar";
import Footer from "../../components/Footer";

const Maani = () => <span>Maani</span>;

const Home: FC = () => {
  return (
    <div className="flex flex-col items-center  min-h-screen bg-gray-100 p-4 md:pt-14 md:pl-40 md:pr-40 overflow-y-auto ">
      <div className="hero flex flex-row-reverse items-center justify-between p-4 rounded-2xl w-full  h-screen">
        <div className=" flex flex-col justify-between h-full items-end text-right ">
          <img
            src={logo}
            alt="logo"
            className="w-1/3 md:w-auto mb-2 md:mb-0 md:mr-4 "
          />
          <span className=" text-sm md:text-4xl font-semibold text-white ">
            {texts.yourWantedCreditSituation}
            <br />
            {texts.find}
            <br />
            {texts.compare}
            <br /> !{texts.selectIt}
          </span>
        </div>
        <img
          src={heroMobileImage}
          alt="heroMobileImage"
          className="w-1/3 h-auto md:max-w-xs md:mb-auto "
        />
        <span className="text-sm md:text-4xl font-semibold md:leading-8 text-left text-white mb-auto ">
          Discover,
          <br />
          Compare
          <br />
          and Conquer
          <br /> Your Perfect Loan!
        </span>
      </div>
      <NavBar />

      <div className="content mt-6 w-full">
        <h2 className=" font-semibold text-gray text-left  text-xl md:text-3xl ">
          Discover Loan Options Effortlessly with Maani
        </h2>
        <p className="mt-4 text-gray  md:text-sm text-xs ">
          <Maani /> is a cutting-edge loan discovery platform designed to
          simplify the way you explore and compare loan plans from trusted
          merchants. Whether you're looking for flexible credit solutions or
          installment purchase, <Maani /> brings a world of opportunities right
          to your fingertips.
          <br />
          <br />
          With <Maani />, you can browse through a curated selection of loan
          options tailored to your needs—quickly, securely, and without the
          hassle of sharing personal information. Our platform ensures that your
          experience is smooth and private, allowing you to review various loan
          plans with ease.
          <br />
          From online shopping to in-store financing, <Maani /> empowers you to
          make informed decisions by providing transparent, up-to-date details
          on loan offers. Whether you’re comparing interest rates, repayment
          terms, or eligibility criteria, <Maani /> connects you with the right
          options without overwhelming you with complex processes. <br />
          <br />
          Experience a seamless, user-friendly way to explore loan opportunities
          today. Trust <Maani /> to guide you in finding the ideal financing
          solution for your life—no personal data required, just better loan
          choices. Explore smarter. Choose <Maani />.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Home;
